import axios from 'axios';
import { AppConfig, JWT, CountryCode, CompanyTypes } from '../../config';
import { CompanyAction } from '../../actions';
import { Translate as t } from '../../config/Translate';
import { ORG_HQ } from '../../config/appConstants';
import { isCompanyUpdateFieldEditable } from '../../lib/companyPermissionGuard';

// 회사 정보·연락처 입력 칸 정의 (AdminCompanyEdit / AdminCompanyList 공용).
// BUG-194 / IMP-415: org / parentCompanyId 는 BE 가 su 전용으로 강제한다. 편집만 열어두면
//   저장 시점에 무음 drop(org) 또는 403(parentCompanyId)으로 끝나므로, 애초에 시도하지
//   않도록 disabled + 자물쇠로 사유를 노출한다 (IMP-407 선례). BE 가 fail-closed SSoT.
export const buildCompanyFormControls = ({ company, companyId, editable, authUser, userCombo }) => {
    const c = company ?? {};
    const suFieldEditable = (fieldName) => editable && isCompanyUpdateFieldEditable(fieldName, authUser);
    const lockBadgeFor = (fieldName) => isCompanyUpdateFieldEditable(fieldName, authUser) ? '' : ' 🔒';

    const info = [
        { type: "input", name: "name", label: t('common.field.name'), val: c.name, required: true, isEditable: editable },
        { type: "select", name: "country", label: t('common.field.country'), val: c.country, list: CountryCode, required: true, isEditable: editable },
        {
            type: "select",
            name: "org",
            label: `${t('company.label.organization')}${lockBadgeFor('org')}`,
            val: c.org,
            list: (CompanyTypes ?? []).filter(x => authUser?.isMegagen ? x.code != ORG_HQ : x.code == x.code),
            required: true,
            isEditable: suFieldEditable('org')
        },
        { type: "select2", name: "operator", label: t('user.label.defaultOperator'), val: c.operator || [], list: userCombo, required: true, isEditable: editable, isMulti: true },
        { type: "input", name: "state", label: t('common.field.state'), val: c.state, isEditable: editable },
        { type: "tel", name: "zip", label: t('common.field.zipCode'), val: c.zip, isEditable: editable },
        { type: "input", name: "region", label: t('common.field.region'), val: c.region, isEditable: editable },
        {
            type: "combo",
            name: "parentCompanyId",
            label: `${t('company.field.parentCompany')}${lockBadgeFor('parentCompanyId')}`,
            val: c.parentCompanyId,
            startval: "None",
            getCombo: CompanyAction.GetCombo,
            isEditable: suFieldEditable('parentCompanyId')
        },
        { type: "input", name: "address", label: t('common.field.address'), val: c.address, size: 12, isEditable: editable },
        { type: "input", name: "addressExtra", label: t('common.field.addressExtra'), val: c.addressExtra, size: 12, isEditable: editable },
        { type: "textarea", name: "note", label: t('common.field.note'), val: c.note, size: 12, isEditable: editable },
    ];

    const contact = [
        { type: "email", name: "contactEmail", label: t('common.field.email'), val: c.contactEmail, required: true, isEditable: editable },
        { type: "tel", name: "contactTel", label: t('common.field.tel'), val: c.contactTel, isEditable: editable },
        { type: "tel", name: "contactHp", label: t('common.field.mobile'), val: c.contactHp, isEditable: editable },
        { type: "tel", name: "contactFax", label: t('common.field.fax'), val: c.contactFax, isEditable: editable },
        { type: "input", name: "contactWebsite", label: t('common.field.website'), val: c.contactWebsite, size: 12, isEditable: editable },
        { type: "input", name: "ownerName", label: t('common.field.ownerName'), val: c.ownerName, isEditable: editable },
        { type: "tel", name: "ownerHp", label: t('common.field.ownerMobile'), val: c.ownerHp, isEditable: editable },
        { type: "email", name: "ownerEmail", label: t('common.field.ownerEmail'), val: c.ownerEmail, isEditable: editable },
    ];

    return [
        { title: t('company.label.companyInformation'), items: info.filter(x => companyId == 'RAY02091' ? (x.name != 'org' && x.name != 'parentCompanyId') : true) },
        { title: t('common.label.contactInformation'), items: contact },
    ];
};

// 지사 사용자 콤보 — operator select2 + IssueManagerSection 공용. 실패 시 [] + warn.
export const fetchBranchUserCombo = async () => {
    let list = [];
    try {
        const ret = await axios.post(AppConfig.API_SERVER_PATH + '/user', { type: 'branchUsers' }, JWT());
        if (ret.data.status == 'success') {
            // IMP-340: 사용자 콤보 이름(title)순 정렬
            list = (ret.data.data || [])
                .map(u => ({ code: u.adminid, title: u.name }))
                .sort((a, b) => (a.title || '').localeCompare(b.title || ''));
        }
    } catch (error) {
        console.warn('[AdminCompanyEdit.getCompanyUsers] failed', {
            handler: 'AdminCompanyEdit.getCompanyUsers',
            reason: error?.message || String(error),
        });
    }
    return list;
};
